// @flow
import { useContext } from 'react';

import versionContext from './version-context';


const useVersion = () => useContext(versionContext);

export default useVersion;
